var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogOutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logout_FILL0_wght400_GRAD0_opsz48") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-\\u21B3-Mobile-navigation-2023",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-menu-/-Pyha-/-Logged-in-menu",
    transform: "translate(-324.000000, -322.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logout_FILL0_wght400_GRAD0_opsz48",
    transform: "translate(324.000000, 322.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,24 C1.46666667,24 1,23.8 0.6,23.4 C0.2,23 0,22.5333333 0,22 L0,2 C0,1.46666667 0.2,1 0.6,0.6 C1,0.2 1.46666667,0 2,0 L11.7,0 L11.7,2 L2,2 L2,22 L11.7,22 L11.7,24 L2,24 Z M18.2,17.8333333 L16.7666667,16.4 L20.1666667,13 L8.5,13 L8.5,11 L20.1,11 L16.7,7.6 L18.1333333,6.16666667 L24,12.0333333 L18.2,17.8333333 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutIcon);
export default __webpack_public_path__ + "static/media/log-out-icon.6af9a40f8f0639c89f437c9eeacd1814.svg";
export { ForwardRef as ReactComponent };